// extracted by mini-css-extract-plugin
module.exports = {"modal":"CauseDetailsList_modal__Nzvc_","modalFooter":"CauseDetailsList_modalFooter__v2v3A"};